import { MasterProfile } from '../types';

export function parseCvTextToProfile(rawText: string, currentProfile: MasterProfile): MasterProfile {
  const lines = rawText.split('\n').map(l => l.trim()).filter(Boolean);
  const textLower = rawText.toLowerCase();

  // Extract Email
  const emailMatch = rawText.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
  const email = emailMatch ? emailMatch[0] : currentProfile.email;

  // Extract Phone (UK format or standard)
  const phoneMatch = rawText.match(/(?:(?:\+44\s?\(0\)\s?|\+44\s?|0)[1-9]\d{1,4}\s?\d{3,4}\s?\d{3,4})/);
  const phone = phoneMatch ? phoneMatch[0] : currentProfile.phone;

  // Extract Name (first meaningful line or pattern)
  let fullName = currentProfile.fullName;
  if (lines.length > 0 && lines[0].length < 40 && !lines[0].includes('@')) {
    fullName = lines[0];
  }

  // Detect Cybersecurity & MSP Skills
  const cyberSkillDictionary = [
    "Cybersecurity", "Information Security", "SOC Analyst", "SIEM", "Incident Response",
    "Vulnerability Assessment", "Penetration Testing", "Cyber Essentials", "ISO 27001",
    "NIST Framework", "Network Security", "Firewall Configuration", "EDR / Endpoint Security",
    "Microsoft 365 Security", "Entra ID / Azure AD", "Active Directory", "MSP Operations",
    "IT Support Tier 2/3", "Hardening", "Threat Intelligence", "Phishing Simulation",
    "Security Auditing", "Compliance", "Wireshark", "Splunk", "Sentinel", "CrowdStrike",
    "Qualys", "Nessus", "Python Scripting", "Linux / Windows Server", "Backup & Disaster Recovery"
  ];

  const detectedSkills = cyberSkillDictionary.filter(skill => 
    textLower.includes(skill.toLowerCase())
  );

  // If detected, combine with any existing unique skills
  const allSkills = Array.from(new Set([
    ...(detectedSkills.length > 0 ? detectedSkills : []),
    ...currentProfile.skills
  ]));

  // Auto-detect professional title
  let title = "Cybersecurity & Information Security Specialist";
  if (textLower.includes("msp") && textLower.includes("security")) {
    title = "MSP Cybersecurity & IT Infrastructure Consultant";
  } else if (textLower.includes("soc") || textLower.includes("incident")) {
    title = "Information Security & SOC Analyst";
  } else if (textLower.includes("compliance") || textLower.includes("iso 27001") || textLower.includes("cyber essentials")) {
    title = "Information Security & Compliance Specialist";
  }

  // Build high-impact summary
  const summary = `Results-oriented Cybersecurity & Information Security Specialist with proven expertise across MSP environments, threat analysis, security auditing, and system hardening. Proficient in ${allSkills.slice(0, 5).join(', ')}. Experienced in delivering immediate overflow security audits, vulnerability remediations, and compliance readiness for UK businesses and managed service providers.`;

  return {
    ...currentProfile,
    fullName,
    email,
    phone,
    title,
    summary,
    skills: allSkills.length > 0 ? allSkills : currentProfile.skills
  };
}
